import React, { FC } from "react";

import "./feedbackTextareaField.scss";

type FeedbackTextareaFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  maxLength: number;
  rows?: number;
};

export const FeedbackTextareaField: FC<FeedbackTextareaFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  maxLength,
  rows = 3,
}) => (
  <div className="feedback-textarea-field">
    <label className="feedback-textarea-field__label" htmlFor={id}>
      {label}
    </label>
    <div className="feedback-textarea-field__wrap">
      <div className="feedback-textarea-field__box">
        <textarea
          id={id}
          className="feedback-textarea-field__textarea"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={rows}
          aria-describedby={`${id}-char-count`}
        />
        <div
          id={`${id}-char-count`}
          className="feedback-textarea-field__meta"
          aria-live="polite"
        >
          <span className="feedback-textarea-field__char-count">
            {value.length}/{maxLength}
          </span>
        </div>
      </div>
    </div>
  </div>
);
